(function () {
    'use strict';

    var controllerId = 'headerCtrl';
    angular.module('app').controller(controllerId,
        ['$window','$scope','$location', '$route', 'config', 'routes', headerCtrl]);

    function headerCtrl($window, $scope, $location, $route, config, routes) {
        var vm = this;
        $scope.currentUser_v1 = angular.isDefined($scope.currentUser);
        console.log('hereHead:'+$scope.currentUser_v1);
        console.log($scope);
        if( $scope.currentUser_v1 === true ){
          document.getElementById('headdiv').style.display = 'block';
        }
        vm.isCurrent = isCurrent;
        vm.showSideBar = 1;
        vm.user_name = $window.sessionStorage.user_name;

        $scope.$on('$routeChangeSuccess', function(event, routeData){
            // Your $routeParams-dependent logic goes here
            //vm.page_title =  routeData.$$route.title;
        });

        activate();

        function activate() { getNavRoutes();}

        function getNavRoutes() {
            vm.navRoutes = routes.filter(function(r) {
                return r.config.settings && r.config.settings.nav;
            }).sort(function(r1, r2) {
                return r1.config.settings.nav - r2.config.settings.nav;
            });
        }

        function isCurrent(route) {
            if (!route.config.title || !$route.current || !$route.current.title) {
                return '';
            }
            var menuName = route.config.title;
            return $route.current.title.substr(0, menuName.length) === menuName ? 'current' : '';
        }
    };
})();
